import * as BABYLON from "babylonjs";
import AssetLoader from "../loaders/AssetLoader";

const START_SPEED = 0;
const MAX_SPEED = 5; //10

class Snow {
  constructor(scene) {
    // Create & launch a particule system
    var particleSystem = new BABYLON.ParticleSystem(
      "spawnParticles",
      1600,
      scene
    ); // 3600 particles to have a continue effect when computing circle positions
    // particleSystem.particleTexture = AssetLoader.getTexture('Snow')
    particleSystem.particleTexture = AssetLoader.getTexture("SnowFlakes");
    // scene.registerBeforeRender(function() {
    // particleSystem.startSpriteCellID = Math.round(Math.random() * 3 - 1);
    // particleSystem.endSpriteCellID = particleSystem.startSpriteCellID;
    // });
    particleSystem.name = "SNOW";
    particleSystem.startSpriteCellID = 0;
    particleSystem.endSpriteCellID = 1;
    particleSystem.spriteCellHeight = 64;
    particleSystem.spriteCellWidth = 64;
    particleSystem.spriteRandomStartCell = true;
    // particleSystem.spriteCellChangeSpeed = .1;
    particleSystem.isAnimationSheetEnabled = true;
    // particleSystem.color1 = new BABYLON.Color4(0.95, 0.95, 0.95, 1.0);
    // particleSystem.color2 = new BABYLON.Color4(0.2, 0.2, 0.2, 0.5);
    // particleSystem.colorDead = new BABYLON.Color4(0, 0, 0.2, 0.0);
    particleSystem.color1 = new BABYLON.Color4(1, 1, 1);
    particleSystem.color2 = new BABYLON.Color4(1, 1, 1);
    particleSystem.colorDead = new BABYLON.Color4(1, 1, 1);

    particleSystem.emitter = new BABYLON.Vector3(0, 10, 0);
    particleSystem.minSize = 0.05; //.3
    particleSystem.maxSize = 0.1; //.7
    particleSystem.emitRate = 250; //500
    // particleSystem.blendMode = BABYLON.ParticleSystem.BLENDMODE_ONEONE; // to manage alpha
    // particleSystem.gravity = new BABYLON.Vector3(0, -1, START_SPEED);
    particleSystem.gravity = new BABYLON.Vector3(0, -0.1, START_SPEED);
    particleSystem.direction1 = new BABYLON.Vector3(-1, 1, -1);
    particleSystem.direction2 = new BABYLON.Vector3(1, 1, 1);
    particleSystem.minEmitPower = -1;
    particleSystem.maxEmitPower = -3;
    particleSystem.minLifeTime = 4; //7
    particleSystem.maxLifeTime = 4; //7
    particleSystem.minAngularSpeed = 0;
    particleSystem.maxAngularSpeed = 3.1416;
    particleSystem.minInitialRotation = 0;
    particleSystem.maxInitialRotation = 3.1416;
    particleSystem.billboardMode = BABYLON.AbstractMesh.BILLBOARDMODE_ALL;
    particleSystem.blendMode = BABYLON.ParticleSystem.BLENDMODE_STANDARD;
    // particleSystem.updateSpeed = 0.1;

    var radius = 30;

    // Custom function to get the circle effect
    particleSystem.startPositionFunction = (worldMatrix, positionToUpdate) => {
      const [randX, randY, randZ] = this.randomCircleCoords(
        radius,
        particleSystem.minEmitBox.y
      );
      BABYLON.Vector3.TransformCoordinatesFromFloatsToRef(
        randX,
        randY,
        randZ,
        worldMatrix,
        positionToUpdate
      );
    };

    particleSystem.preWarmCycles = 100;
    particleSystem.preWarmStepOffset = 5;

    // Start
    particleSystem.start();
    this.particleSystem = particleSystem;

    this.isPaused = false;
    this.animater = particleSystem.animate;
    this.pauseAnimater = () => void 0;
  }

  stop () {
    this.isPaused=true;
    this.particleSystem.stop();
    this.particleSystem.reset();
    this.particleSystem.animate = this.pauseAnimater;
  }

  restart() {
    this.particleSystem.start();
    this.particleSystem.animate = this.animater;
    this.isPaused = false;
  }

  pause() {
    if (this.isPaused === false) {
      this.particleSystem.animate = this.pauseAnimater;
      this.isPaused = true;
    }
  }

  resume() {
    if (this.isPaused) {
      this.particleSystem.animate = this.animater;
      this.isPaused = false;
    }
  }

  changeSpeed(percent) {
    const newSpeed = (MAX_SPEED - START_SPEED) * percent + START_SPEED;
    this.particleSystem.gravity.z = newSpeed;
  }

  randomCircleCoords(radius, yBase) {
    var rndAngle = 2 * Math.random() * Math.PI;
    var randX = Math.random() * radius * Math.sin(rndAngle);
    var randY = yBase;
    var randZ = Math.random() * radius * Math.cos(rndAngle) - 15;

    return [randX, randY, randZ];
  }
}

export default Snow;
